import React, { useEffect, useState } from 'react';
import Adminsidebar from './Adminsidebar';
import { Typography, TextField } from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const Adminuser = () => {
  const { id } = useParams(); 
  const [user, setUser] = useState(null);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    try {
      const res = await axios.get(`/api/user/${id}`);
      setUser(res.data.user);
      setHistory(res.data.history);
    } catch (err) {
      console.error(err);
    }
  };

  if (!user) return <div>Loading...</div>;

  return (
    <div className='admin-dashoardpanel'>
      <Adminsidebar />

      <div className='customdatatable-wrapper'>
        <div className='dashboard-header'>
          <Typography variant='h2'>User Details</Typography>
        </div>

        <div className='tiles-filter-wrapper'>
          <form>
            <div className='form-field'>
              <TextField
                label="Name"
                value={user?.user_name || ''}
                variant='outlined'
                fullWidth
                disabled
              />
            </div>

            <div className='form-field'>
          
              <TextField
                label="Phone No."
                value={user?.user_number || ''}
                variant='outlined'
                fullWidth
                disabled
              />
            </div>

            <div className='form-field'>
              <TextField
                label="Result"
                value={user?.user_result || ''}
                variant='outlined'
                fullWidth
                disabled
              />
            </div>
          </form>
        </div>

        <div className='tiles-filter-wrapper chat-histy'>
          <Typography variant='h2'>User Chat History</Typography>

          <div className='history-wrapper'>
            {history.map((item, index) => {
              const isImage = item.answer?.startsWith("/images");

              return (
                <div className='question' key={index}>
                  {/* Question */}
                  <div className='adminchat'>
                    <Typography variant='body1'>
                      {item.question}
                    </Typography>
                  </div>

                  <div className='userchat'>
                    {isImage ? (
                      <img
                        src={`${item.answer}`}
                        alt="uploaded"
                        style={{
                          width: "180px",
                          borderRadius: "10px",
                          marginTop: "10px"
                        }}
                      />
                    ) : (
                      <Typography variant='body1'>
                        {item.answer}
                      </Typography>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Adminuser;